import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = { class: "switch" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "switch-name" }, " 视频通话 ", -1)
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "switch-name" }, " 音频通话 ", -1)
const _hoisted_8 = {
  class: "switch",
  style: {"margin-left":"40px"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "switch-name" }, " 开启 AI 降噪 ", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "switch-name" }, " 关闭 AI 降噪 ", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "call-kit-container" }
const _hoisted_14 = { class: "hover" }
const _hoisted_15 = { class: "search" }
const _hoisted_16 = { class: "search-window search-left" }
const _hoisted_17 = { class: "search-title" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 登录其他 UserID ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    "fill-rule": "evenodd",
    d: "M10.75 1a.75.75 0 0 0 0 1.5h1.69L8.22 6.72a.75.75 0 0 0 1.06 1.06l4.22-4.22v1.69a.75.75 0 0 0 1.5 0V1h-4.25ZM2.5 4v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V8.75a.75.75 0 0 1 1.5 0V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4.25a.75.75 0 0 1 0 1.5H3a.5.5 0 0 0-.5.5Z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("g", { fill: "none" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M0 0h24v24H0z" }),
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M19 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2V4a2 2 0 0 1 2-2h10Zm-4 6H5v12h10V8Zm-5 7a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h2Zm9-11H9v2h6a2 2 0 0 1 2 2v8h2V4Zm-7 7a1 1 0 0 1 .117 1.993L12 13H8a1 1 0 0 1-.117-1.993L8 11h4Z"
    })
  ])
], -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "search-input-container" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "search-window search-right" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "selected-title" }, "拨打列表", -1)
const _hoisted_28 = { class: "search-results" }
const _hoisted_29 = { class: "user-item" }
const _hoisted_30 = { class: "userID" }
const _hoisted_31 = { class: "user-email" }
const _hoisted_32 = ["src", "onClick"]
const _hoisted_33 = { class: "call-buttons" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, "Debug Panel", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 目前 userID: ")
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "SDKAppID: ", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", null, "SecretKey: ", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"12px"} }, [
  /*#__PURE__*/_createTextVNode(" 注意️：本 Debug Panel 仅用于调试，正式上线前请将 UserSig 计算代码和密钥迁移到您的后台服务器上，以避免加密密钥泄露导致的流量盗用。 "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://cloud.tencent.com/document/product/647/17275",
    target: "_blank"
  }, "查看文档")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", null, "UserID: ", -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode()
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { ref, onMounted, onUnmounted } from "vue";
import { TUICallKit, TUICallKitServer, TUICallKitMini } from "../../..";
import DeviceDetector from "./components/DeviceDetector/index.vue";
import * as GenerateTestUserSig from "../public/debug/GenerateTestUserSig.js";
import TIM from "tim-js-sdk";
import { copyText } from "vue3-clipboard";
import videoBlackSVG from "./assets/videoBlack.svg";
import videoWhiteSVG from "./assets/videoWhite.svg";
import audioWhiteSVG from "./assets/audioWhite.svg";
import audioBlackSVG from "./assets/audioBlack.svg";
import searchSVG from "./assets/search.svg";
import cancelSVG from "./assets/cancel.svg";
import { ElMessage } from 'element-plus';
import logReporter from "./utils/aegis";
import "./App.css";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const SDKAppID = ref<number>(0);
const SecretKey = ref<string>("");
const userID = ref<string>("");
const loginUserID = ref<string>("");
const userList = ref<string[]>([]);
const currentUserID = ref<string>("未登录");

const debugDisplayStyle = ref<string>("");
const isNewTab = ref<boolean>(false);
const isMinimized = ref<boolean>(false);
const lang = ref<string>("zh-cn");
const finishedRTCDetectStatus = ref<string>("");
const isSkippedRTCDetect = ref<boolean>(false);

const typeString = ref<string>("video");
const isCalling = ref<boolean>(false);
const groupID = ref<string>("");
const aiReduceChecked = ref<boolean>(false);
let tim: any = null;

onMounted(() => {
  if (getQueryVariable("SDKAppID") === false) SDKAppID.value = 0;
  else {
    SDKAppID.value = parseInt(getQueryVariable("SDKAppID") as string);
    isNewTab.value = true;
  }
  SecretKey.value = getQueryVariable("SecretKey") || "";
  finishedRTCDetectStatus.value = localStorage.getItem('callkit-basic-demo-finish-rtc-detect') || "";
});

onUnmounted(() => {
  TUICallKitServer.destroyed();
  tim.logout();
})

function logout() {
  TUICallKitServer.destroyed();
  aiReduceChecked.value = false;
  tim.logout();
}

async function login() {
  if (!SDKAppID.value || SDKAppID.value === 0) {
    alert("请填写 SDKAppID");
    return;
  }
  if (!SecretKey.value) {
    alert("请填写 SecretKey");
    return;
  }
  if (!loginUserID.value) {
    alert("请填写 userID");
    return;
  }
  const { userSig } = GenerateTestUserSig.genTestUserSig(
    loginUserID.value,
    SDKAppID.value,
    SecretKey.value
  );
  tim = TIM.create({
    SDKAppID: SDKAppID.value,
  });
  try {
    await TUICallKitServer.init({
      userID: loginUserID.value,
      userSig,
      SDKAppID: SDKAppID.value,
      tim,
      assetsPath: 'https://web.sdk.qcloud.com/trtc/webrtc/test/rg-test/TUICallKit-AI/',
    });
    currentUserID.value = loginUserID.value;
    debugDisplayStyle.value = "display: none;";
    if (finishedRTCDetectStatus.value !== "finished") initNetWorkInfo();
    logReporter.loginSuccess(SDKAppID.value);
  } catch (error: any) {
    if (error.message) ElMessage.error(`登录失败，请检查 SDKAppID 与 SecretKey 是否正确 ${error.message}`);
    logReporter.loginFailed(SDKAppID.value, error?.message);
  }
}

function switchCallType(type: string) {
  if (isCalling.value) return;
  typeString.value = type;
}

async function startCall(typeString: string) {
  if (currentUserID.value === "未登录") {
    alert("未登录");
    return;
  }
  const type = typeString === "audio" ? 1 : 2;
  if (userList.value.length <= 0) return;
  const callType = (userList.value.length === 1) ? "call" : "groupCall";
  try {
    if (userList.value.length === 1)
      await TUICallKitServer.call({ userID: userList.value[0], type });
    else {
      // you can use existing groups, no need to create a new group every time
      groupID.value = await createGroup();
      await TUICallKitServer.groupCall({
        userIDList: userList.value,
        type,
        groupID: groupID.value,
      });
    }
    logReporter.callSuccess(SDKAppID.value, callType, typeString);
  } catch (error: any) {
    console.error("startCall", error);
    if (error.message) ElMessage.error(error.message);
    logReporter.callFailed(SDKAppID.value, callType, typeString, error?.message);
  }
}

function beforeCalling(type: string, error: any) {
  console.log("basic demo beforeCalling", type, error);
  if (!error) isCalling.value = true;
  else {
    console.error("basic demo beforeCalling", error);
    ElMessage.error(`${error.type}: ${error.message}`);
  }
}

function afterCalling() {
  userList.value = [];
  isCalling.value = false;
  isMinimized.value = false;
  aiReduceChecked.value = false;
}

function onMinimized(oldStatus: boolean, newStatus: boolean) {
  console.warn("onMinimized: " + oldStatus + " -> " + newStatus);
  if (newStatus === true) {
    isMinimized.value = true;
  } else {
    isMinimized.value = false;
  }
}

function addUser(userIDParam: string) {
  if (!userIDParam) return;
  let index = userList.value.indexOf(userIDParam);
  index < 0 && userList.value.push(userIDParam);
  userID.value = "";
}

function removeUser(userID: string) {
  let index = userList.value.indexOf(userID);
  index > -1 && userList.value.splice(index, 1);
}

async function createGroup() {
  const memberList: any[] = [];
  userList.value.forEach((user: string) => {
    memberList.push({ userID: user });
  });
  console.warn(memberList);
  let res = await tim.createGroup({
    type: TIM.TYPES.GRP_PUBLIC,
    name: "group-call",
    memberList,
  });
  return res.data.group.groupID;
}

function getQueryVariable(variable: string) {
  let query = window.location.search.substring(1);
  let vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}

function newTab(event: any) {
  event.stopPropagation();
  window.open(
    `/?SDKAppID=${SDKAppID.value}&SecretKey=${SecretKey.value}`,
    "_blank"
  );
}

function copyUserID() {
  copyText(currentUserID.value, undefined, (error: any) => {
    if (error) {
      ElMessage.warning(`复制失败，请手动填写`);
    } else {
      ElMessage.success(`已复制`);
    }
  });
}

function changeLang() {
  // if (lang.value === "zh-cn") lang.value = "en";
  // else lang.value = "zh-cn";
}

function handleClose() {
  showDeviceDetector.value = false;
  isSkippedRTCDetect.value = true;
  ElMessage.warning("已跳过设备检测");
}

function handleFinishDetect() {
  showDeviceDetector.value = false;
  finishedRTCDetectStatus.value = "finished";
  localStorage.setItem('callkit-basic-demo-finish-rtc-detect', 'finished');
}

const networkDetectInfo = ref();
const showDeviceDetector = ref<boolean>(false);

const initNetWorkInfo = async () => {
  if (!SDKAppID.value || !SecretKey.value) {
    ElMessage.error("请填写正确的 SDKAppID 与 SecretKey 后重试");
    return;
  };
  const status = localStorage.getItem('callkit-basic-demo-finish-rtc-detect');
  if (status === 'finished') return;
  const uplinkUserId = currentUserID.value + '_uplink_test';
  const downlinkUserId = currentUserID.value + '_downlink_test';
  const roomId = 999999;

  const uplinkUserSig = GenerateTestUserSig.genTestUserSig(
    uplinkUserId,
    SDKAppID.value,
    SecretKey.value
  ).userSig;
  const downlinkUserSig = GenerateTestUserSig.genTestUserSig(
    downlinkUserId,
    SDKAppID.value,
    SecretKey.value
  ).userSig;
  networkDetectInfo.value = {
    sdkAppId: SDKAppID,
    roomId,
    uplinkUserInfo: {
      uplinkUserId,
      uplinkUserSig,
    },
    downlinkUserInfo: {
      downlinkUserId,
      downlinkUserSig,
    },
  };
  showDeviceDetector.value = true;
}
const aiReduceOperate = async (status: boolean) => {
  if (!isCalling.value) {
    return;
  }
  if (currentUserID.value === "未登录") {
    alert("未登录");
    return;
  }
  aiReduceChecked.value = status;
  if (status) {
    await TUICallKitServer.enableAiNoiseReduce();
  } else {
    await TUICallKitServer.disableAiNoiseReduce();
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DeviceDetector, {
      visible: showDeviceDetector.value,
      onClose: handleClose,
      onFinish: handleFinishDetect,
      networkDetectInfo: networkDetectInfo.value
    }, null, 8, ["visible", "networkDetectInfo"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["switch-btn", typeString.value === 'video' ? 'switch-select' : '']),
          style: _normalizeStyle(isCalling.value ? 'cursor: not-allowed' : 'cursor: pointer'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (switchCallType('video')))
        }, [
          _createElementVNode("img", {
            src: typeString.value === 'video' ? _unref(videoWhiteSVG) : _unref(videoBlackSVG),
            class: "icon"
          }, null, 8, _hoisted_4),
          _hoisted_5
        ], 6),
        _createElementVNode("div", {
          class: _normalizeClass(["switch-btn", typeString.value === 'audio' ? 'switch-select' : '']),
          style: _normalizeStyle(isCalling.value ? 'cursor: not-allowed' : 'cursor: pointer'),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (switchCallType('audio')))
        }, [
          _createElementVNode("img", {
            src: typeString.value === 'audio' ? _unref(audioWhiteSVG) : _unref(audioBlackSVG),
            class: "icon"
          }, null, 8, _hoisted_6),
          _hoisted_7
        ], 6)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: _normalizeClass(["switch-btn", aiReduceChecked.value ? 'switch-select' : '']),
          style: _normalizeStyle(isCalling.value ? 'cursor: pointer' : 'cursor: not-allowed'),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (aiReduceOperate(true)))
        }, _hoisted_10, 6),
        _createElementVNode("div", {
          class: _normalizeClass(["switch-btn", !aiReduceChecked.value ? 'switch-select' : '']),
          style: _normalizeStyle(isCalling.value ? 'cursor: pointer' : 'cursor: not-allowed'),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (aiReduceOperate(false)))
        }, _hoisted_12, 6)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _withDirectives(_createElementVNode("div", _hoisted_14, " 已进入最小化模式 ", 512), [
        [_vShow, isCalling.value && isMinimized.value]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createTextVNode(_toDisplayString(typeString.value === "video" ? "视频通话" : "音频通话") + " ", 1),
            (currentUserID.value !== '未登录')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "user-id",
                  onClick: copyUserID
                }, [
                  _createTextVNode(" userID: " + _toDisplayString(currentUserID.value) + " ", 1),
                  (!isNewTab.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[4] || (_cache[4] = (event) => newTab(event))
                      }, _hoisted_20))
                    : (_openBlock(), _createElementBlock("span", _hoisted_21, _hoisted_23))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("img", {
              src: _unref(searchSVG),
              class: "icon-search"
            }, null, 8, _hoisted_25),
            _withDirectives(_createElementVNode("input", {
              class: "search-input",
              type: "text",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((userID).value = $event))
            }, null, 512), [
              [_vModelText, userID.value]
            ])
          ]),
          _createElementVNode("div", {
            class: "add-btn",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (addUser(userID.value)))
          }, "添加到拨打列表")
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userList.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "result-item",
                key: item
              }, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, _toDisplayString(item), 1),
                  _createElementVNode("div", _hoisted_31, _toDisplayString(item), 1)
                ]),
                _createElementVNode("img", {
                  src: _unref(cancelSVG),
                  class: "checkbox cancel",
                  onClick: ($event: any) => (removeUser(item))
                }, null, 8, _hoisted_32)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_33, [
            _withDirectives(_createElementVNode("div", {
              class: "rtc-detector-starter",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (initNetWorkInfo()))
            }, "开始设备检测", 512), [
              [_vShow, currentUserID.value !== '未登录' && finishedRTCDetectStatus.value !== 'finished']
            ]),
            _createElementVNode("div", {
              class: "call-btn",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (startCall(typeString.value)))
            }, "通话")
          ])
        ])
      ], 512), [
        [_vShow, !isCalling.value || isMinimized.value]
      ]),
      _withDirectives(_createVNode(_unref(TUICallKit), {
        beforeCalling: beforeCalling,
        afterCalling: afterCalling,
        onMinimized: onMinimized,
        allowedMinimized: true,
        allowedFullScreen: true,
        lang: lang.value
      }, null, 8, ["lang"]), [
        [_vShow, isCalling.value]
      ]),
      _createVNode(_unref(TUICallKitMini))
    ]),
    _createElementVNode("div", {
      id: "debug",
      style: _normalizeStyle(debugDisplayStyle.value)
    }, [
      _createElementVNode("div", null, [
        _hoisted_34,
        _hoisted_35,
        _hoisted_36,
        _createElementVNode("span", null, "(" + _toDisplayString(currentUserID.value) + ")", 1)
      ]),
      _hoisted_37,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((SDKAppID).value = $event)),
        placeholder: "SDKAppID",
        type: "number",
        style: {"width":"100px"}
      }, null, 512), [
        [_vModelText, SDKAppID.value]
      ]),
      _hoisted_38,
      _hoisted_39,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((SecretKey).value = $event)),
        placeholder: "SecretKey",
        style: {"width":"500px"}
      }, null, 512), [
        [_vModelText, SecretKey.value]
      ]),
      _hoisted_40,
      _hoisted_41,
      _hoisted_42,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((loginUserID).value = $event)),
        placeholder: "UserID"
      }, null, 512), [
        [_vModelText, loginUserID.value]
      ]),
      _hoisted_43,
      _createElementVNode("button", {
        onClick: _cache[12] || (_cache[12] = ($event: any) => (login()))
      }, "登录")
    ], 4)
  ]))
}
}

})